import { getHashedEmail, queueAnalyticsEvent, SeoEvent } from 'lib/gtm'
import { SyneriseFormEvent, syneriseSendFormData } from 'lib/synerise'
import type { CustomerTypes } from 'modules/customer'
import { isCustomerAdult } from 'modules/customer'

export const addZipCodeSeo = ({
  customer,
  zipCode,
  isAvailable
}: {
  customer?: CustomerTypes
  zipCode: string
  isAvailable: boolean
}) => {
  const eventData = {
    event: SeoEvent.ADD_ZIP_CODE, //constant
    label: zipCode, //added zipcode
    delivery: isAvailable ? 'available' : 'unavailable', //available if zip code is ok for delivery, unavailable if we don't deliver for this zipcode
    type: 'other events', //constant
    user_id: customer?.code || undefined, //User ID from crm if logged in, if not we return undefined
    user_adult: isCustomerAdult(customer?.dateOfBirth),
    hashed_email: getHashedEmail(customer?.email), //customer email in md5 - if logged in, if not we return undefined
  }

  queueAnalyticsEvent(eventData)
}

export const reportPostalCodeCheckResult = ({
  customer,
  zipCode,
  isAvailable
}: {
  customer?: CustomerTypes
  zipCode: string
  isAvailable: boolean
}) => {
  addZipCodeSeo({ customer, zipCode, isAvailable })
  syneriseSendFormData({
    formData: {
      zipCode,
      isAvailable
    },
    event: SyneriseFormEvent.DELIVERY_AREA_CHECK
  })
}
